export default __webpack_public_path__ + "static/media/DrVipulDalal.10729088.jpg";